import { render, staticRenderFns } from "./ProposeModal.vue?vue&type=template&id=9068ef88&"
import script from "./ProposeModal.vue?vue&type=script&lang=js&"
export * from "./ProposeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports